import Vue from 'vue';
// CommonJS
import VueTimepicker from 'vue2-timepicker/dist/VueTimepicker.common.js'
import 'vue2-timepicker/dist/VueTimepicker.css';

Vue.mixin({
    components: {
        VueTimepicker
    }
});